import EventsModule from "modules/events.module";
import HeaderModule from "modules/headerObserver.module";
import NavigationModule from "modules/navigation.module";


class App {

	private headerModule = new HeaderModule()
	private navigationModule = new NavigationModule()
	private eventsModule = new EventsModule()

	constructor() {
		// HEADER METHODS
		this.headerModule.addWatcherToHeaderOnScroll()
		this.headerModule.setHeaderShadow()
		this.headerModule.headerHasBoxShadow()


		// NAVIGATION METHODS
		this.navigationModule.disableAttributes()
		this.navigationModule.handleActiveLinkOnPageLoad()
		this.navigationModule.handleNavBarToggleButton()
		this.navigationModule.handleNavBarDropdown()

		// EVENT METHODS
		this.eventsModule.handleAttendanceEventSelection()
	}
}

export const myApp = new App();
